export class CodeListMainRequest{
    codeListMainId : number;
    
    constructor(codeListMainId : number)
    {
        this.codeListMainId = codeListMainId;
        
    }
}
